import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component DollarOffSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <DollarOffSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <DollarOffSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarOffSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      data-testid="DollarOffSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m1.05 1.05 9.9 9.9-.707.707L8.47 9.883A1 1 0 0 1 8 10H7v1H5v-1H4a1 1 0 0 1-1-1V8h1v.7a.3.3 0 0 0 .3.3h3.286l-3-3H4a1 1 0 0 1-1-1v-.587L.342 1.757zM8 5a1 1 0 0 1 1 1v1.586l-1-1V6.3a.3.3 0 0 0-.3-.3h-.286l-1-1zM7 1v1h1a1 1 0 0 1 1 1v1H8v-.7a.3.3 0 0 0-.3-.3H4.414l-.883-.883C3.67 2.042 3.83 2 4 2h1V1z"
      />
    </svg>
  )
);
DollarOffSmallIcon.displayName = "DollarOffSmallIcon";
export default DollarOffSmallIcon;
